import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import React, { useState, useRef, useEffect } from 'react';
import { useFormik } from 'formik';
import { Api } from '../../services/api.js';
import { Toast } from 'primereact/toast';
import './BuilderForm.css'
import { Dropdown } from 'primereact/dropdown';

function BuilderForm() {
  const [projectData, setProjectData] = useState([]);
  const [selectedProjectType, setSelectedProjectType] = useState([]);

  const [budgetRange, setBudgetRange] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('');


  const handleBudgetChange = (event) => {
    setBudgetRange(event.target.value);
  };

  useEffect(() => {
    console.log('working')
    localStorage.clear();

    getProjectDetails();



    return () => {
      // Cleanup tasks before the component is unmounted
    };

  }, []);

  const getProjectDetails = () => {


    fetch(Api.API_BASE_URL + '/leads-tracker/leads-dropdown-list-for-form', {
      method: "GET",

    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);
        setSelectedProjectType(response.project_type);
        setBudgetRange(response.project_value);
        setSelectedLeadSource(response.lead_source);

      })
      .catch((error) => {
        // setIsLoading(false);
        console.error("Error:", error);
      });
  }

  // ----------------------------------------------------------------------------

  const toast = useRef(null);

  const formik = useFormik({
    initialValues: {
      "first_name": "",
      "last_name": "",
      "email": "",
      "phone_number": "",
      "address": "",
      "city": "",
      "postal_code": "",
      "lead_source": "",
      "project_type": "",
      "project_value": "",
      "project_desc": "",
      "who_referred_you": ""
    },
    validate: (data) => {

    },

    onSubmit: (data) => {
      console.log("data");
      console.log(data);
      setIsLoading(true);

      var url = Api.API_BASE_URL + '/leads-tracker/builder-leads-create';


      fetch(url, {
        method: "POST",
        headers: {

        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          if (Josn.error != '') {
            setIsLoading(false);
            setToastMessage(Josn.error);
           // toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

          } else {
            setIsLoading(false);
            setToastMessage(Josn.result);
            //toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
            formik.resetForm();

          }

          // Clear toast message after 2 seconds
          setTimeout(() => {
            setToastMessage('');
            setToastSeverity('');
          }, 5000);

        })
        .catch((error) => {
          console.error("Error:", error);
        });


    }
  });


  const [showNewFieldRefferlBy, setShowNewFieldRefferlBy] = useState(false);
  const handlehowToGet = (event) => {
 
    formik.setFieldValue('lead_source', event.target.value)
    setShowNewFieldRefferlBy(false)
    if(event.target.value=="Referral"){
      setShowNewFieldRefferlBy(true)
    }
  }
  // ----------------------------------------------------------------------------

  return (

    <div className="Builder" >
      <Toast ref={toast} />
      <form className=" rounded  p-3 pb-8 mb-3" onSubmit={formik.handleSubmit} >
        <div className="mb-3 ">
          <label className="block text-gray-700 mb-1" htmlFor="firstName">
            First Name <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty   w-full py-2 px-2  text-gray-700  "
            id="firstName"
            value={formik.values.first_name}
            onChange={(e) => formik.setFieldValue('first_name', e.target.value)}
            type="text"
            // placeholder="First Name"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700  mb-1" htmlFor="lastName" font-lato>
            Last Name <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-2  text-gray-700  "
            id="lastName"
            value={formik.values.last_name}
            onChange={(e) => formik.setFieldValue('last_name', e.target.value)}
            type="text"
            // placeholder="Last Name"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="email">
            Email <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-2  text-gray-700 "
            id="email"
            value={formik.values.email}
            onChange={(e) => formik.setFieldValue('email', e.target.value)}
            type="email"
            // placeholder="Email"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="phone">
            Phone <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-2  text-gray-700 "
            id="phone"
            value={formik.values.phone_number}
            onChange={(e) => formik.setFieldValue('phone_number', e.target.value)}
            type="tel"
            // placeholder="Phone"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="street_number">
          Street Number <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-2  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="street_number"
            value={formik.values.street_number}
            required
            onChange={(e) => formik.setFieldValue('street_number', e.target.value)}
            type="text"
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="street_name">
          Street Name <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-2  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="street_name"
            value={formik.values.street_name}
            required
            onChange={(e) => formik.setFieldValue('street_name', e.target.value)}
            type="text"
          />
        </div>
        {/* <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="projectAddress">
            Project Address <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-2  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="projectAddress"
            value={formik.values.address}
            required
            onChange={(e) => formik.setFieldValue('address', e.target.value)}
            type="text"
          />
        </div> */}
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="city">
            City <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-4  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="city"
            value={formik.values.city}
            onChange={(e) => formik.setFieldValue('city', e.target.value)}
            required
            type="text"
          // placeholder="City"

          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="postalCode">
            Postal Code <span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="postalCode"
            type="text"
            value={formik.values.postal_code}
            required
            onChange={(e) => formik.setFieldValue('postal_code', e.target.value)}
          // placeholder="Postal Code"

          />
        </div>
        
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="howDidYouHear">
            How did you hear about us? <span style={{ color: "red" }}>*</span>
          </label>
          {/* <MultiSelect value={formik.values.lead_source}  onChange={(e) => formik.setFieldValue('lead_source', e.target.value)} optionLabel="name" optionValue='id' display="chip" placeholder="Select Cities" maxSelectedLabels={3} options={selectedLeadSource}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          /> */}
          <Dropdown value={formik.values.lead_source} onChange={(e) => handlehowToGet(e)} optionLabel="name" optionValue='id' filter display="chip" placeholder="--No Item Selected --" required options={selectedLeadSource}
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />    
          {/* <Dropdown value={formik.values.lead_source} onChange={(e) => formik.setFieldValue('lead_source', e.target.value)} optionLabel="name" optionValue='id' filter display="chip" placeholder="--No Item Selected --" required options={selectedLeadSource}
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          /> */}
        </div>

       {showNewFieldRefferlBy?<div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="who_referred_you">
          Who Referred You <span style={{ color: "red" }}>*</span>
          </label>
          <InputText

            className="InputTexty shadow appearance-none border rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="who_referred_you"
            type="text"
            value={formik.values.who_referred_you}
            required
            onChange={(e) => formik.setFieldValue('who_referred_you', e.target.value)}
          // placeholder="Postal Code"

          />
        </div>:<div></div>} 
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="projectType">
            Project Type <span style={{ color: "red" }}>*</span>
          </label>

          <Dropdown value={formik.values.project_type} onChange={(e) => formik.setFieldValue('project_type', e.target.value)} optionLabel="name" filter optionValue='id' placeholder="Select an Option" options={selectedProjectType}
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          />
        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="budgetRange">
            Budget Range <span style={{ color: "red" }}>*</span>
          </label>
          <Dropdown value={formik.values.project_value} onChange={(e) => formik.setFieldValue('project_value', e.target.value)} optionLabel="name" filter optionValue='id' placeholder="Select Budget" maxSelectedLabels={3} options={budgetRange}
            className="InputTexty shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          />

        </div>
        <div className="mb-3">
          <label className="block text-gray-700 mb-1" htmlFor="projectDescription">
            Project Description <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            className="shadow rounded w-full py-2 px-3 text-gray-700 "
            id="projectDescription"
            value={formik.values.project_desc}
            onChange={(e) => formik.setFieldValue('project_desc', e.target.value)}
            // placeholder="Project Description"
            required
            rows="7"
          ></textarea>
        </div>
        <div className="flex items-center justify-between">
          <button
            className="submit-btn uppercase text-white  py-2 px-5 border-none"
            type="submit" disabled={isLoading}
          >
            {isLoading ? 'Loading...' : 'SAVE'}
          </button>
        </div>
        {/* <div  className="flex d-flex justify-content-center" >
         
             <div style={{ marginTop: '15px',fontSize:'18px', color: 'black', textAlign: 'center',fontWeight:'normal', width:'65%'  }}>
             Thank you for reaching out to us! Your message has been successfully submitted. We appreciate your interest and will get back to you as soon as possible. In the meantime, feel free to explore more of our website or check out our latest projects.
            </div>
       
        </div>  */}
        <div  className="flex d-flex justify-content-center" >
          {toastMessage && (
              <div style={{ marginTop: '15px',fontSize:'18px', color: 'black', textAlign: 'center',fontWeight:'normal', width:'65%'  }}>
              {toastMessage}
            </div>
          )}
        </div>
        {/* {toastMessage && <h2 style={{marginTop:'15px',color: toastSeverity === 'success' ? 'green' : 'red' }}>{toastMessage}</h2>} */}
      </form>
    </div>
  );
}

export default BuilderForm;
